import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './en/translation.json';
import he from './he/translation.json';

i18next
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    fallbackLng: 'he-IL',
    supportedLngs: ['he-IL', 'en-US'],
    load: 'all',
    resources: {
      'he-IL': { translation: he },
      'en-US': { translation: en },
    },
    detection: {
      order: ['localStorage'],
      caches: ['localStorage'],
    },
    interpolation: {
      escapeValue: false,
    },
  })
  .then(() => {
    // force language only if it's the first visit (no i18nextLng saved)
    if (!localStorage.getItem('i18nextLng')) {
      i18next.changeLanguage('he-IL');
    }
  });
